import { AppType } from '../utils';

const util = {};

util.flatten = function(array){
    let l = [];
    for (let i = 0; i < array.length; i++) {
        if(array[i] instanceof Array){
            l = l.concat(util.flatten(array[i]))
        } else{
            l.push(array[i])
        }
    }
    return l
};

util.contextHasWidget = function(context,type){
    return util.widgetsOfType(context,type).length>0;
}

util.widgetsOfType = function(context, type){
    let allWidgets = util.extractWidgetsWithPageInfo(context.pages);

    if (context.appTypeId === AppType.LOCKDOWN && !!context.sliderChildren) {
        const sliderChildWidgets = util.extractWidgetsWithPageInfo(context.sliderChildren);
        allWidgets = allWidgets.concat(sliderChildWidgets);
    }

    let flattened = util.flatten(allWidgets);
    let filtered = flattened.filter(function(x){return !type || x.type === type});
    return filtered;
};

util.extractWidgetsWithPageInfo = function(list) {
    return list.map(item =>
        item.widgets.map(widget => {
            widget.page = { name: item.name, id: item.id, formName: item.formName };
            return widget;
        })
    );
};

util.parseString = function(str){
    if(typeof str !== 'string'){
        return ''+str
    }

    if((str[0]==="'" && str[str.length-1]==="'") || (str[0] === '"' && str[str.length-1] === '"') ){
        str = str.substring(1);
        str = str.substring(0,str.length-1);
    }
    return str
}


util.displayPageName = function (page){
    if(page.formName){
        return page.formName + " > " + page.name
    }
    else {
        return page.name
    }
}

util.trimmedPageName = function (page, length){
    let halfLen = Math.floor(length/2);
    let pageName;

    if(page.name.length>halfLen){
        pageName = page.name.substring(0,halfLen-2) + "..." + page.name.substring(page.name.length-(halfLen+1),page.name.length);
    } else{
        pageName = page.name;
    }

    if(page.formName){
        let formName;
        if(page.formName.length>halfLen){
            formName = page.formName.substring(0,halfLen-2) + "..." + page.formName.substring(page.formName.length-(halfLen+1),page.formName.length);
        } else{
            formName = page.formName;
        }
        return formName + " > " + pageName;
    }

    return pageName;
}

export default util